import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "export-wallet",
  "use": "export-wallet-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"export-wallet\"><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M13.872 11.725v.266a2 2 0 0 1-2 2H3.944a2 2 0 0 1-2-2V6.537a2 2 0 0 1 2-2h7.928a2 2 0 0 1 2 2v.74\" /><path stroke=\"currentColor\" d=\"M5.054 4.537 8.72 2.419a2 2 0 0 1 2.732.732l.843 1.46\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"m10.6 7.247 1.664 1.663a.5.5 0 0 1 0 .707L10.6 11.281M12.446 9.264H8M4.802 9.264H4.03\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol